;(function () {
  'use strict'

  angular
    .module('contrast.technology')
    .factory('TechnologyService', [
      'ServiceUtils',
      'TechnologyFactory',
      TechnologyService
    ])

  function TechnologyService(ServiceUtils, TechnologyFactory) {
    var service = {
      getTechs: getTechs
    }

    return service

    /**
     * @param validLanguages
     */
    function getTechs(validLanguages) {
      return TechnologyFactory.getTechs(validLanguages)
        .then(ServiceUtils.handleResolve('data.techs'))
        .catch(ServiceUtils.handleError)
    }
  }
})()
